import { OrthographicCamera } from "three";

const left = 0;
const right = 1;
const top = 0;
const bottom = 1;
const near = -10000000;
const far = 1;

class StageCamera {
  constructor(l, r, t, b, f, n) {
    this.camera = new OrthographicCamera(
      l || left,
      r || right,
      t || top,
      b || bottom,
      f || far,
      n || near
    );
  }

  setXFrustum(x0, x1) {
    this.camera.left = x0;
    this.camera.right = x1;
    this.adjust();
  }

  setYFrustum(y0, y1) {
    this.camera.top = y0;
    this.camera.bottom = y1;
    this.adjust();
  }

  adjust() {
    this.camera.updateProjectionMatrix();
  }
}

export default StageCamera;
